module.exports = __webpack_public_path__ + "img/GERENTE_Matias_Penhos.d587a1c5.jpg";